<template>
  <div class="impressum">
    <p>Jakob Schlosser</p>
    <p>4020 Linz</p>
  </div>
</template>
